import { useState, useCallback, useEffect } from "react";
import PlayAudioVisibilityContext from "./PlayAudioVisibilityContext";

const PlayAudioVisibilityProvider = ({ children }) => {
  const [playAudio, setPlayAudio] = useState("muted");

  const setPlayVis = useCallback((type) => {
    window.localStorage.setItem("Play Audio Visibility", type);
    setPlayAudio(type);
  }, []);

  const changeToMutedAudio = useCallback(() => {
    setPlayVis("muted");
  }, [setPlayVis]);

  const changeToPlayAudio = useCallback(() => {
    setPlayVis("play");
  }, [setPlayVis]);

  useEffect(() => {
    const localplayAudioVis = window.localStorage.getItem(
      "Play Audio Visibility"
    );
    if (localplayAudioVis) {
      setPlayAudio(localplayAudioVis);
    } else {
      setPlayAudio("muted");
      window.localStorage.setItem("Play Audio Visibility", "muted");
    }
  }, [playAudio]);

  return (
    <PlayAudioVisibilityContext.Provider
      value={{ playAudio, changeToMutedAudio, changeToPlayAudio }}
    >
      {children}
    </PlayAudioVisibilityContext.Provider>
  );
};

export default PlayAudioVisibilityProvider;
